<template>
  <div class="blocks">
    <div class="l-m-b-20 align-items-center d-flex justify-content-between">
      <div class="d-flex align-items-center title-search">
        <h1 class="pr-3">Dashboard</h1>
        <div v-if="$_can('subco.dashboard.view') && dashboardType === 'subco'" class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control search-input" type="text" v-model="q" @keyup="searchText($event)"
                 placeholder="Search"
          />
        </div>
      </div>
      <div class="text-right pr-0 d-flex">
        <div v-if="$_can('subco.dashboard.view') && $_can('sales.dashboard.view')" class="change-dashboard-wrap">
          <simple-select v-model="dashboardType"
                         :options="dashboardTypes"
                         label="name"
                         placeholder="Change Dashboard"
          />

          <span class="mod-icon-chevron-down mr-3 position-absolute" />
        </div>

        <router-link tag="button" class="btn btn-primary btn-schedule" to="/schedule">
          <!-- <div class="mod-icon mod-icon-rates" />-->
          SCHEDULE
        </router-link>
      </div>
    </div>
    <template v-if="$_can('sales.dashboard.view') && dashboardType === 'sales'">
      <SalesDashboard />
    </template>
    <template v-else-if="$_can('subco.dashboard.view') && dashboardType === 'subco'">
      <!-- Tabs -->
      <div class="row mb-3">
        <div class="col">
          <div class="mb-4 nav nav-tabs nav-fill">
            <div :class="[step === 'todayAndTomorrow' ? 'active' : '']"
                 class="nav-item nav-link pointer"
                 @click="setStep('todayAndTomorrow')"
            >
              Today and tomorrow
            </div>
            <div :class="[step === 'upcoming' ? 'active' : '']"
                 class="nav-item nav-link pointer"
                 @click="setStep('upcoming')"
            >
              Upcoming
            </div>
            <div :class="[step === 'completed' ? 'active' : '']"
                 class="nav-item nav-link pointer"
                 @click="setStep('completed')"
            >
              Completed jobs
            </div>
            <div :class="[step === 'incomplete' ? 'active' : '']"
                 class="nav-item nav-link pointer"
                 @click="setStep('incomplete')"
            >
              Incomplete jobs
            </div>
          </div>
        </div>
      </div>

      <div class="l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="col-12 filters-field" v-if="$_can('subco.dashboard.view')">
          <span>Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.carrier.length && carriers">
              <span v-for="carrier in filters.carrier" :key="carrier" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('carrier', carrier)" />
                Carrier: {{ carriers.find(el => el.id === carrier).name }}</span>
            </span>
            <span v-if="filters.company.length && companies">
              <span v-for="company in filters.company" :key="company" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('company', company)" />
                Company: {{ companies.find(el => el.id === company).name }}</span>
            </span>
            <span v-if="filters.userCompanies && clusterUsersFilter.length" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('userCompanies')" />
              User companies: {{ clusterUsersFilter.find(el => el.id === filters.userCompanies).full_name }}</span>
            <span v-if="filters.moveSize" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('moveSize')" />
              Move Size: {{ moveSizes.find(el => el.id === filters.moveSize).name }}</span>
            <span v-if="filters.moveDate" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('moveDate')" />
              Move Date: {{ filters.moveDate }}</span>
            <span v-if="filters.status" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('status')" />
              Status: {{ jobStatuses.find(el => el.id === filters.status).name }}</span>
            <span v-if="filters.cash_collected" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('cash_collected')" />
              Cash collected: {{ filters.cash_collected === 'true' ? 'Yes' : 'No' }}</span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
      </div>

      <!-- Step todayAndTomorrow -->
      <section v-show="step === 'todayAndTomorrow'">
        <!-- TODAY -->
        <div class="row mb-4">
          <div class="col-12">
            <label>TODAY</label>
            <div class="pull-right">
              <span class="btn-status bg-grey border-right">{{ metaToday && metaToday.total }}</span>
              <span class="btn-status bg-grey">{{ metaToday && metaToday.unassigned }} not assigned</span>
              <button class="btn btn-secondary expand-all" @click="toggleAllTodayJobs" :disabled="jobsToday && !jobsToday.length">
                <i :class="[jobsToday && expandedAllToday ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <template v-if="!jobsToday">
          <vue-content-loading :width="800" :height="180">
            <rect v-for="x in 5" :key="x" x="10" :y="15*x*1.8" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div v-if="jobsToday && jobsToday.length">
            <JobsBlock
              v-for="(job, index) in jobsToday"
              :key="index"
              :job.sync="job"
              :index.sync="index"
              :expanded="expandedToday"
              :dashboard="true"
              @job-updated="updateJob(jobsToday, index, $event)"
              @expanded="toggleJobToday"
              @update="callGetJobsToday"
              @showModalAcceptJob="showModalAcceptJob = true"
            />
          </div>
          <div v-if="jobsToday && !jobsToday.length">
            No results found
          </div>
          <pagination :change-page="changePage" :meta="metaToday" :day="'today'" />
        </template>

        <!-- TOMORROW -->
        <div class="row mt-5 mb-4">
          <div class="col-12">
            <label>TOMORROW</label>
            <div class="pull-right">
              <span class="btn-status bg-grey border-right">{{ metaTomorrow && metaTomorrow.total }}</span>
              <span class="btn-status bg-grey">{{ metaTomorrow && metaTomorrow.unassigned }} not assigned</span>
              <button class="btn btn-secondary expand-all" @click="toggleAllTomorrowJobs" :disabled="jobsTomorrow && !jobsTomorrow.length">
                <i :class="[jobsTomorrow && expandedAllTomorrow ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <template v-if="!jobsTomorrow">
          <vue-content-loading :width="800" :height="180">
            <rect v-for="x in 5" :key="x" x="10" :y="15*x*1.8" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div v-if="jobsTomorrow && jobsTomorrow.length">
            <JobsBlock
              v-for="(job, index) in jobsTomorrow"
              :key="index"
              :job.sync="job"
              :index.sync="index"
              :expanded="expandedTomorrow"
              :dashboard="true"
              @job-updated="updateJob(jobsTomorrow, index, $event)"
              @expanded="toggleJobTomorrow"
              @update="callGetJobsTomorrow"
              @showModalAcceptJob="showModalAcceptJob = true"
            />
          </div>

          <div v-if="jobsTomorrow && !jobsTomorrow.length">
            No results found.
          </div>
          <pagination :change-page="changePage" :meta="metaTomorrow" :day="'tomorrow'" />
        </template>
      </section>

      <!-- Step upcoming -->
      <section v-show="step === 'upcoming'">
        <!-- UPCOMING -->
        <div class="row">
          <div class="col-12 l-m-b-20">
            <label>UPCOMING</label>
            <div class="pull-right">
              <span class="btn-status bg-grey border-right">{{ metaUpcoming && metaUpcoming.total }}</span>
              <span class="btn-status bg-grey">{{ metaUpcoming && metaUpcoming.unassigned }} not assigned</span>
              <button class="btn btn-secondary expand-all" @click="toggleAllUpcomingJobs" :disabled="jobsUpcoming && !jobsUpcoming.length">
                <i :class="[jobsUpcoming && expandedAllUpcoming ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <template v-if="!jobsUpcoming">
          <vue-content-loading :width="800" :height="180">
            <rect v-for="x in 5" :key="x" x="10" :y="15*x*1.8" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div v-if="jobsUpcoming && jobsUpcoming.length">
            <JobsBlock
              v-for="(job, index) in jobsUpcoming"
              :key="index"
              :job.sync="job"
              :index.sync="index"
              :expanded="expandedUpcoming"
              :dashboard="true"
              @job-updated="updateJob(jobsUpcoming, index, $event)"
              @expanded="toggleJobUpcoming"
              @update="callGetJobsUpcoming"
              @showModalAcceptJob="showModalAcceptJob = true"
            />
          </div>
          <div v-if="!jobsUpcoming && !jobsUpcoming.length">
            No results found.
          </div>
          <pagination :change-page="changePageUpcoming" :meta="metaUpcoming" />
        </template>
      </section>

      <!-- Step completed -->
      <section v-show="step === 'completed'">
        <!-- COMPLETED -->
        <div class="row">
          <div class="col-12 l-m-b-20">
            <label>COMPLETED</label>
            <div class="pull-right">
              <span class="btn-status bg-grey border-right">{{ metaCompleted && metaCompleted.total }}</span>
              <span class="btn-status bg-grey">{{ metaCompleted && metaCompleted.unassigned }} not assigned</span>
              <button class="btn btn-secondary expand-all" @click="toggleAllCompletedJobs" :disabled="jobsCompleted && !jobsCompleted.length">
                <i :class="[jobsCompleted && expandedAllCompleted ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <template v-if="!jobsCompleted">
          <vue-content-loading :width="800" :height="180">
            <rect v-for="x in 5" :key="x" x="10" :y="15*x*1.8" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div v-if="jobsCompleted && jobsCompleted.length">
            <JobsBlock
              v-for="(job, index) in jobsCompleted"
              :key="index"
              :job.sync="job"
              :index.sync="index"
              :expanded="expandedCompleted"
              :dashboard="true"
              @job-updated="updateJob(jobsCompleted, index, $event)"
              @expanded="toggleCompletedJob"
              @update="callGetJobsCompleted"
            />
          </div>
          <div v-if="jobsCompleted && !jobsCompleted.length">
            No results found.
          </div>
          <pagination :change-page="changePageCompleted" :meta="metaCompleted" />
        </template>
      </section>

      <!-- Step incomplete -->
      <section v-show="step === 'incomplete'">
        <!-- INCOMPLETE -->
        <div class="row">
          <div class="col-12 l-m-b-20">
            <label>INCOMPLETE</label>
            <div class="pull-right">
              <span class="btn-status bg-grey border-right">{{ metaIncomplete && metaIncomplete.total }}</span>
              <span class="btn-status bg-grey">{{ metaIncomplete && metaIncomplete.unassigned }} not assigned</span>
              <button class="btn btn-secondary expand-all" @click="toggleAllIncompleteJobs" :disabled="jobsIncomplete && !jobsIncomplete.length">
                <i :class="[jobsIncomplete && expandedAllIncomplete ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <template v-if="!jobsIncomplete">
          <vue-content-loading :width="800" :height="180">
            <rect v-for="x in 5" :key="x" x="10" :y="15*x*1.8" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div v-if="jobsIncomplete && jobsIncomplete.length">
            <JobsBlock
              v-for="(job, index) in jobsIncomplete"
              :key="index"
              :job.sync="job"
              :index.sync="index"
              :expanded="expandedIncomplete"
              :dashboard="true"
              @job-updated="updateJob(jobsIncomplete, index, $event)"
              @expanded="toggleIncompleteJob"
              @update="callGetJobsIncomplete"
              @showModalAcceptJob="showModalAcceptJob = true"
            />
          </div>
          <div v-if="jobsIncomplete && !jobsIncomplete.length">
            No results found.
          </div>
          <pagination :change-page="changePageIncomplete" :meta="metaIncomplete" />
        </template>
      </section>
    </template><!-- Close check permission -->

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Company</label>
                      <key-multiselect v-model="filters.company"
                                       :options="companies"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'company-select'"
                                       :placeholder="'Select Company'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="carriers && carriers.length">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'carrier-select'"
                                       :placeholder="'Select Carriers'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="clusterUsersFilter && clusterUsersFilter.length">
                    <div class="select-wrap">
                      <label>User companies</label>
                      <simple-select v-model="filters.userCompanies"
                                     :options="clusterUsersFilter"
                                     :input-id="'user-companies-select'"
                                     placeholder="Select User"
                                     @input="search"
                                     track-by="id"
                                     label="full_name"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move Size</label>
                      <simple-select v-model="filters.moveSize"
                                     :options="moveSizes"
                                     :input-id="'move-size-select'"
                                     placeholder="Select Move Size"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.moveDate"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearDateAndSearch"
                            v-if="filters.moveDate"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Status</label>
                      <simple-select v-model="filters.status"
                                     :options="jobStatuses"
                                     :input-id="'status-select'"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Cash collected</label>
                      <simple-select v-model="filters.cash_collected"
                                     :options="booleanOptions"
                                     :input-id="'has-subscription-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import moment from 'moment/moment';
import FlatPickr from 'vue-flatpickr-component/src/component';
import Pagination from '../Pagination';
import JobsBlock from '../jobs/JobsBlock';
import SalesDashboard from './salesDashboard/SalesDashboard';
import SimpleSelect from '../SimpleSelect';

export default {
  name: 'Dashboard',
  components: { SalesDashboard, JobsBlock, Pagination, FlatPickr, SimpleSelect },
  data: () => ({
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
    expandedToday: [],
    expandedTomorrow: [],
    expandedUpcoming: [],
    expandedCompleted: [],
    expandedIncomplete: [],
    expandedAllToday: false,
    expandedAllTomorrow: false,
    expandedAllUpcoming: false,
    expandedAllCompleted: false,
    expandedAllIncomplete: false,
    filters: {
      carrier: [],
      company: [],
      moveSize: '',
      moveDate: '',
      startDate: '',
      endDate: '',
      status: '',
      sortOrders: '',
      userCompanies: '',
      cash_collected: '',
    },
    stepFilters: {
      completed: {
        carrier: [],
        company: [],
        moveSize: '',
        moveDate: '',
        startDate: moment()
          .subtract(7, 'day')
          .format('MM/DD/YYYY'),
        endDate: moment().format('MM/DD/YYYY'),
        status: '',
        sortOrders: '',
        userCompanies: '',
      },
      incomplete: {
        carrier: [],
        company: [],
        moveSize: '',
        moveDate: '',
        startDate: moment()
          .subtract(6, 'month')
          .format('MM/DD/YYYY'),
        endDate: moment()
          .subtract(1, 'day')
          .format('MM/DD/YYYY'),
        status: '',
        sortOrders: '',
        userCompanies: '',
      },
      todayAndTomorrow: {
        carrier: [],
        company: [],
        moveSize: '',
        moveDate: '',
        startDate: '',
        endDate: '',
        status: '',
        sortOrders: '',
        userCompanies: '',
      },
      upcoming: {
        carrier: [],
        company: [],
        moveSize: '',
        moveDate: '',
        startDate: '',
        endDate: '',
        status: '',
        sortOrders: '',
        userCompanies: '',
      },
    },
    perPage: 5,
    page: {
      completed: 1,
      incomplete: 1,
      today: 1,
      tomorrow: 1,
      upcoming: 1,
    },
    q: '',
    showFilters: false,
    showTooltipCancellationNote: [],
    sortKey: 'move_date',
    step: 'todayAndTomorrow',
    today: new Date(),
    upcomingSortKey: `${this.sortKey},arrival_windows.from`,
    dashboardType: null,
    dashboardTypes: [
      {
        id: 'subco',
        name: 'Subco dashboard',
      },
      {
        id: 'sales',
        name: 'Sales dashboard',
      },
    ],
    booleanOptions: [
      {
        id: 'true',
        name: 'Yes',
      },
      {
        id: 'false',
        name: 'No',
      },
    ],
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      clusterUsersFilter: state => state.clusterUsers.clusterUsers,
      companies: state => state.companies.companies.data,
      filtersLoaded: state => state.guard.filtersLoaded,
      jobStatuses: state => state.values.jobStatuses,
      jobsCompleted: state => state.jobs.jobsCompleted.data,
      jobsIncomplete: state => state.jobs.jobsIncomplete.data,
      jobsToday: state => state.jobs.jobsToday.data,
      jobsTomorrow: state => state.jobs.jobsTomorrow.data,
      jobsUpcoming: state => state.jobs.jobsUpcoming.data,
      metaCompleted: state => state.jobs.jobsCompleted.meta,
      metaIncomplete: state => state.jobs.jobsIncomplete.meta,
      metaToday: state => state.jobs.jobsToday.meta,
      metaTomorrow: state => state.jobs.jobsTomorrow.meta,
      metaUpcoming: state => state.jobs.jobsUpcoming.meta,
      moveSizes: state => state.values.moveSizes,
      permissions: state => state.guard.permissions,
      user: state => state.auth.dispatchUser,
    }),
    ...mapGetters([
      'getJobsToday',
      'getJobsTomorrow',
      'getJobsUpcoming',
      'getJobsCompleted',
      'getJobsIncomplete',
    ]),
    clearFiltersButtonShouldBeDisabled() {
      return (
        !this.filters.carrier.length &&
        !this.filters.company.length &&
        !this.filters.moveSize &&
        !this.filters.moveDate &&
        !this.filters.status &&
        !this.filters.userCompanies &&
        !this.filters.cash_collected
      );
    },
  },
  watch: {
    dashboardType() {
      if (this.dashboardType === 'subco') {
        this.loadSubcoDashboard();
      }
    },
    jobsTomorrow() {
      if (this.jobsTomorrow && this.expandedAllTomorrow) {
        this.jobsTomorrow.forEach(job => {
          this.expandedTomorrow.push(job.id);
        });
      } else {
        this.expandedTomorrow = [];
      }
    },
    jobsToday() {
      if (this.jobsToday && this.expandedAllToday) {
        this.jobsToday.forEach(job => {
          this.expandedToday.push(job.id);
        });
      } else {
        this.expandedToday = [];
      }
    },
    jobsUpcoming() {
      if (this.jobsUpcoming && this.expandedAllUpcoming) {
        this.jobsUpcoming.forEach(job => {
          this.expandedUpcoming.push(job.id);
        });
      } else {
        this.expandedUpcoming = [];
      }
    },
    jobsCompleted() {
      if (this.jobsCompleted && this.expandedAllCompleted) {
        this.jobsCompleted.forEach(job => {
          this.expandedCompleted.push(job.id);
        });
      } else {
        this.expandedCompleted = [];
      }
    },
    jobsIncomplete() {
      if (this.jobsIncomplete && this.expandedAllIncomplete) {
        this.jobsIncomplete.forEach(job => {
          this.expandedIncomplete.push(job.id);
        });
      } else {
        this.expandedIncomplete = [];
      }
    },
    permissions() {
      if (this.permissions && this.permissions.length > 0) {
        if (this.$_can('sales.dashboard.view')) {
          this.dashboardType = 'sales';
        } else if (this.$_can('subco.dashboard.view')) {
          this.dashboardType = 'subco';
          this.loadSubcoDashboard();
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.permissions && this.permissions.length > 0) {
        if (this.$_can('sales.dashboard.view')) {
          this.dashboardType = 'sales';
        } else if (this.$_can('subco.dashboard.view')) {
          this.dashboardType = 'subco';
          this.loadSubcoDashboard();
        }
      }
    });
  },
  methods: {
    ...mapMutations([
      'setJobsCompleted',
      'setJobsIncomplete',
      'setJobsToday',
      'setJobsTomorrow',
      'setJobsUpcoming',
    ]),
    loadSubcoDashboard() {
      const { query } = this.$route;
      if (Object.keys(query).length !== 0) {
        if (query.step && query.step.toString() !== this.step) {
          this.step = query.step.toString();
        }
        this.setFilters();
      } else {
        this.setStep(this.step);
      }
    },
    updateJob(jobs, index, job) {
      this.$set(jobs, index, job);
    },
    setFilters() {
      const { query } = this.$route;
      let moveDateString = query.date_from ? `${query.date_from.toString()}` : '';
      moveDateString += query.date_to ? ` to ${query.date_to.toString()}` : '';
      this.filters = Object.assign(
        {
          carrier: query.carrier_id ? query.carrier_id.split(',').map(i => Number(i)) : [],
          company: query.company_id ? query.company_id.split(',').map(i => Number(i)) : [],
          moveSize: query.move_size_id ? parseInt(query.move_size_id, 10) : '',
          moveDate: moveDateString,
          startDate: query.date_from.toString() ? query.date_from.toString() : '',
          endDate: query.date_to.toString() ? query.date_to.toString() : '',
          status: query.status_id ? parseInt(query.status_id, 10) : '',
          sortOrders: query.order,
          userCompanies: query.user_companies ? parseInt(query.user_companies, 10) : '',
          cash_collected: query.cash_collected ? query.cash_collected : '',
        },
        {},
      );
      this.sortKey = query.sort;
      this.q = query.q.toString();
      Object.entries(query).forEach(([key, value]) => {
        if (key.startsWith('page_')) {
          this.page[key.replace('page_', '')] = value;
        }
      });
      if (query.step) {
        this.setStep(query.step.toString());
      }
    },
    toggleJobTomorrow(value) {
      if (this.expandedTomorrow.includes(value)) {
        const index = this.expandedTomorrow.indexOf(value);
        if (index > -1) {
          this.expandedTomorrow.splice(index, 1);
        }
      } else {
        this.expandedTomorrow.push(value);
      }
    },
    toggleJobToday(value) {
      if (this.expandedToday.includes(value)) {
        const index = this.expandedToday.indexOf(value);
        if (index > -1) {
          this.expandedToday.splice(index, 1);
        }
      } else {
        this.expandedToday.push(value);
      }
    },
    toggleJobUpcoming(value) {
      if (this.expandedUpcoming.includes(value)) {
        const index = this.expandedUpcoming.indexOf(value);
        if (index > -1) {
          this.expandedUpcoming.splice(index, 1);
        }
      } else {
        this.expandedUpcoming.push(value);
      }
    },
    toggleCompletedJob(value) {
      if (this.expandedCompleted.includes(value)) {
        const index = this.expandedCompleted.indexOf(value);
        if (index > -1) {
          this.expandedCompleted.splice(index, 1);
        }
      } else {
        this.expandedCompleted.push(value);
      }
    },
    toggleIncompleteJob(value) {
      if (this.expandedIncomplete.includes(value)) {
        const index = this.expandedIncomplete.indexOf(value);
        if (index > -1) {
          this.expandedIncomplete.splice(index, 1);
        }
      } else {
        this.expandedIncomplete.push(value);
      }
    },
    toggleAllUpcomingJobs() {
      if (!this.expandedUpcoming.length) {
        this.jobsUpcoming.forEach(job => {
          this.expandedUpcoming.push(job.id);
        });
        this.expandedAllUpcoming = true;
      } else {
        this.expandedUpcoming = [];
        this.expandedAllUpcoming = false;
      }
    },
    toggleAllTodayJobs() {
      if (!this.expandedToday.length) {
        this.jobsToday.forEach(job => {
          this.expandedToday.push(job.id);
        });
        this.expandedAllToday = true;
      } else {
        this.expandedToday = [];
        this.expandedAllToday = false;
      }
    },
    toggleAllTomorrowJobs() {
      if (!this.expandedTomorrow.length) {
        this.jobsTomorrow.forEach(job => {
          this.expandedTomorrow.push(job.id);
        });
        this.expandedAllTomorrow = true;
      } else {
        this.expandedTomorrow = [];
        this.expandedAllTomorrow = false;
      }
    },
    toggleAllCompletedJobs() {
      if (!this.expandedCompleted.length) {
        this.jobsCompleted.forEach(job => {
          this.expandedCompleted.push(job.id);
        });
        this.expandedAllCompleted = true;
      } else {
        this.expandedCompleted = [];
        this.expandedAllCompleted = false;
      }
    },
    toggleAllIncompleteJobs() {
      if (!this.expandedIncomplete.length) {
        this.jobsIncomplete.forEach(job => {
          this.expandedIncomplete.push(job.id);
        });
        this.expandedAllIncomplete = true;
      } else {
        this.expandedIncomplete = [];
        this.expandedAllIncomplete = false;
      }
    },
    view(event, id) {
      if (event.button === 1) {
        window.open(
          this.$router.resolve(`/jobs/edit/${id}${this.q ? `?ref_id=${this.q}` : ''}`).href,
          '_blank',
        );
      } else {
        this.$router.push(`/jobs/edit/${id}${this.q ? `?ref_id=${this.q}` : ''}`);
      }
    },
    changePage(pageNum, day) {
      if (day === 'today') {
        this.setJobsToday({});
      } else {
        this.setJobsTomorrow({});
      }
      this.page[day] = pageNum;
      this.filter(day);
    },
    changePageUpcoming(pageNum) {
      this.page.upcoming = pageNum;
      this.setJobsUpcoming({});
      this.filter('upcoming');
    },
    changePageCompleted(pageNum) {
      this.page.completed = pageNum;
      this.setJobsCompleted({});
      this.filter('completed');
    },
    changePageIncomplete(pageNum) {
      this.page.incomplete = pageNum;
      this.setJobsIncomplete({});
      this.filter('incomplete');
    },
    clearSearch() {
      this.q = '';
      if (this.step === 'todayAndTomorrow') {
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.filter(this.step);
      }
    },
    search() {
      if (this.step === 'todayAndTomorrow') {
        this.page.today = 1;
        this.page.tomorrow = 1;
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.page[this.step] = 1;
        this.filter(this.step);
      }
    },
    onDateChange(selectedDates) {
      if (selectedDates[0]) {
        this.filters.startDate = selectedDates[0].toLocaleDateString('en-US') || '';
      }
      if (selectedDates[1]) {
        this.filters.endDate = selectedDates[1].toLocaleDateString('en-US') || '';
      }
      if (selectedDates[0] || selectedDates[1]) {
        this.search();
        this.setFilters(this.$route.query);
      }
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      if (model === 'moveDate') {
        this.filters.moveDate = '';
        this.filters.moveDateStart = '';
        this.filters.moveDateEnd = '';
      }
      this.search();
    },
    filter(day) {
      let queryUrl = `carrier_id=${this.filters.carrier}&company_id=${
        this.filters.company
      }&move_size_id=${this.filters.moveSize}&user_companies=${
        this.filters.userCompanies
      }&move_date=${this.filters.moveDate}&date_from=${this.filters.startDate}&date_to=${
        this.filters.endDate
      }&status=${this.filters.status}&q=${encodeURIComponent(this.q)}&sort=${this.sortKey}&order=${
        this.filters.sortOrders
      }&cash_collected=${this.filters.cash_collected}`;
      queryUrl += `&step=${this.step}`;
      Object.entries(this.page).forEach(([key, value]) => {
        queryUrl += `&page_${key}=${value}`;
      });
      if (day === 'today') {
        this.callGetJobsToday();
      } else if (day === 'tomorrow') {
        this.callGetJobsTomorrow();
      } else if (day === 'upcoming') {
        this.callGetJobsUpcoming();
      } else if (day === 'completed') {
        this.callGetJobsCompleted();
      } else {
        this.callGetJobsIncomplete();
      }
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/?${queryUrl}`);
      } else {
        this.$router.push(`/`);
      }
    },
    sortBy(key) {
      this.sortKey = key;
      this.$set(this.filters, 'sortOrders', this.filters.sortOrders === 'desc' ? 'asc' : 'desc');
      if (this.step === 'todayAndTomorrow') {
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.filter(this.step);
      }
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          carrier: [],
          company: [],
          moveSize: '',
          moveDate: '',
          startDate: '',
          endDate: '',
          status: '',
          sortOrders: '',
          userCompanies: '',
        },
        {},
      );
      this.sortKey = 'move_date';
      if (this.step === 'todayAndTomorrow') {
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.filter(this.step);
      }
      this.showFilters = false;
    },
    clearDateAndSearch() {
      this.filters.moveDate = '';
      this.filters.startDate = '';
      this.filters.endDate = '';
      if (this.step === 'todayAndTomorrow') {
        this.page.today = 1;
        this.page.tomorrow = 1;
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.page[this.step] = 1;
        this.filter(this.step);
      }
    },
    searchText(e) {
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (vm.step === 'todayAndTomorrow') {
            vm.page.today = 1;
            vm.page.tomorrow = 1;
            vm.filter('today');
            vm.filter('tomorrow');
          } else {
            vm.page[this.step] = 1;
            vm.filter(this.step);
          }
        }, 500);
      }
    },
    setStep(step) {
      this.stepFilters[this.step] = this.filters;
      this.step = step;
      this.filters = this.stepFilters[step];
      if (this.step === 'todayAndTomorrow') {
        this.filter('today');
        this.filter('tomorrow');
      } else {
        this.filter(this.step);
      }
      this.setMoveDate();
    },
    setMoveDate() {
      if (this.filters.startDate || this.filters.endDate) {
        this.filters.moveDate =
          (this.filters.startDate ? `${this.filters.startDate}` : '') +
          (this.filters.endDate ? ` to ${this.filters.endDate}` : '');
      }
    },
    showMoversTooltip(day, index) {
      this.$set(this.showMovers[day], index, true);
    },
    hideMoversTooltip(day, index) {
      this.$set(this.showMovers[day], index, false);
    },
    showTrucksTooltip(day, index) {
      this.$set(this.showTrucks[day], index, true);
    },
    hideTrucksTooltip(day, index) {
      this.$set(this.showTrucks[day], index, false);
    },
    callGetJobsToday() {
      const queryToday =
        `page=${this.page.today}&per_page=${this.perPage}&carrier_id=${this.filters.carrier}` +
        `&company_id=${this.filters.company}&move_size_id=${this.filters.moveSize}&user_companies=${
          this.filters.userCompanies
        }` +
        `&status_id=${this.filters.status}&q=${encodeURIComponent(this.q)}&sort=${this.sortKey}` +
        `&order=${this.filters.sortOrders}&cash_collected=${
          this.filters.cash_collected ? this.filters.cash_collected : ''
        }&with=jobMovers,arrivalWindow`;
      this.getJobsToday(queryToday, moment(this.today).format('MM/DD/YYYY'));
    },
    callGetJobsTomorrow() {
      const queryTomorrow =
        `page=${this.page.tomorrow}&per_page=${this.perPage}&carrier_id=${this.filters.carrier}` +
        `&company_id=${this.filters.company}&move_size_id=${this.filters.moveSize}&user_companies=${
          this.filters.userCompanies
        }` +
        `&status_id=${this.filters.status}&q=${encodeURIComponent(this.q)}&sort=${this.sortKey}` +
        `&order=${this.filters.sortOrders}&cash_collected=${
          this.filters.cash_collected ? this.filters.cash_collected : ''
        }&with=jobMovers,arrivalWindow`;
      this.getJobsTomorrow(
        queryTomorrow,
        moment(this.today)
          .add(1, 'days')
          .format('MM/DD/YYYY'),
      );
    },
    callGetJobsUpcoming() {
      this.upcomingSortKey = `${this.sortKey},arrival_windows.from`;
      const queryUpcoming =
        `page=${this.page.upcoming}&carrier_id=${this.filters.carrier}&company_id=${
          this.filters.company
        }` +
        `&move_size_id=${this.filters.moveSize}&user_companies=${this.filters.userCompanies}` +
        `&status_id=${this.filters.status}&cash_collected=${
          this.filters.cash_collected ? this.filters.cash_collected : ''
        }&q=${encodeURIComponent(this.q)}&sort=${this.upcomingSortKey}&order=${
          this.filters.sortOrders
        }&with=jobMovers
      `;
      this.getJobsUpcoming(
        queryUpcoming,
        this.filters.endDate,
        moment(this.today)
          .add(2, 'days')
          .format('MM/DD/YYYY'),
      );
    },
    callGetJobsIncomplete() {
      const queryIncomplete =
        `page=${this.page.incomplete}&carrier_id=${this.filters.carrier}&company_id=${
          this.filters.company
        }` +
        `&move_size_id=${this.filters.moveSize}&user_companies=${this.filters.userCompanies}` +
        `&date_from=${this.filters.startDate}&cash_collected=${
          this.filters.cash_collected ? this.filters.cash_collected : ''
        }&date_to=${this.filters.endDate}&status_id=${this.filters.status}&q=${encodeURIComponent(
          this.q,
        )}&sort=${this.sortKey}&order=${this.filters.sortOrders}&with=jobMovers`;
      this.getJobsIncomplete(queryIncomplete);
    },
    callGetJobsCompleted() {
      const queryCompleted =
        `page=${this.page.completed}&carrier_id=${this.filters.carrier}&company_id=${
          this.filters.company
        }` +
        `&move_size_id=${this.filters.moveSize}&user_companies=${this.filters.userCompanies}` +
        `&date_from=${this.filters.startDate}&date_to=${this.filters.endDate}&status_id=${
          this.filters.status
        }&q=${encodeURIComponent(this.q)}&sort=${this.sortKey}&order=${
          this.filters.sortOrders
        }&with=jobMovers&cash_collected=${
          this.filters.cash_collected ? this.filters.cash_collected : ''
        }`;
      this.getJobsCompleted(queryCompleted);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue